import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'

import Staff from './components/Staff'
import { createPartnerStaff, getPartnerStaffs } from './redux/actions'

import './style/PartnerStaff.scss'
import Search from 'util/modules/Pagination/components/Search'

const initialState = { user: 0, role: '' }
const PartnerStaff: React.FC = () => {
  const [form, setForm] = useState(initialState)

  const dispatch = useDispatch()
  const { partner } = useSelector((state: ApplicationState) => state.partnerReducer)
  const { staff, labels } = useSelector((state: ApplicationState) => state.partnerStaffReducer)

  function handleAdd (e: React.FormEvent): void {
    e.preventDefault()
    if (partner) {
      createPartnerStaff(partner.id, form as any)(dispatch).then(res => {
        if (res?.status === 'success') {
          setForm(initialState)
        }
      })
    }
  }

  useEffect(() => {
    if (partner) {
      getPartnerStaffs(partner.id)(dispatch)
    }
  }, [partner, dispatch])

  if (!partner) {
    return null
  }

  const owner = staff.find(item => item.role === 'OWNER')

  return (
    <div className="row panel margin-top-32 partner-staff">
      <div className="primary ballon">Gestão de pessoas</div>

      <form className="row align-end" onSubmit={handleAdd}>
        <div className="grow padding-right-16">
          <div className="row">
            <div className="form-control col-6">
              <label>Escolha um usuário</label>
              <Search
                url="/user"
                label='name'
                filter='person.name'
                fields='id,person.name'
                filterType="filter_like"
                match={['start']}
                selected={String(form.user)}
                options={{ returnKey: 'id', renderValue: (user) => user.person?.name }}
                onSelect={(user): void => setForm({ ...form, user: Number(user) })}
              />
            </div>

            <div className="form-control col-6">
              <label>Função</label>
              <select
                required
                value={form.role}
                onChange={(e): void => setForm({ ...form, role: e.target.value })}
              >
                <option></option>
                {
                  Object.keys(labels).filter(key => key !== 'OWNER').map((key, i) => {
                    const name = labels[key]
                    return <option value={key} key={i}>{ name }</option>
                  })
                }
              </select>
            </div>
          </div>
        </div>

        <button className="button primary">
          <i className="fas fa-plus"/> Adicionar
        </button>
      </form>

      { owner && <Staff staff={owner} partnerId={partner.id} canRemove={false} /> }
      {
        staff
          .filter(item => item.role !== 'OWNER')
          .map((item, i) => <Staff key={i} staff={item} partnerId={partner.id} />)
      }
    </div>
  )
}

export default PartnerStaff
